import React from 'react';

function Article(props) {
  return <article className="article">{props.children}</article>
}

export default Article;
